export default (siteName) => [
    {
        path: 'accounting-yearly-management',
        name: 'accounting-yearly-management',
        component: () => import('../../components/dashboard/Accounting/AccountingYearlyManagement/indexPage.vue'),
        meta: {
            title: `年度會計總管理${siteName}`,
            activeMenu: 'accounting',
        },
    },
    {
        path: 'accounting-yearly-excluded-voucher-list/:year',
        name: 'accounting-yearly-excluded-voucher-list',
        component: () => import('../../components/dashboard/Accounting/AccountingYearlyManagement/ExcludedVoucherListPage.vue'),
        meta: {
            title: `年度未列入報表的傳票清單${siteName}`,
            activeMenu: 'accounting',
        },
    },
];
